import { Component, OnInit } from "@angular/core";
import { FormBuilder, FormControl, FormGroup, Validators } from "@angular/forms";
import { MatSnackBar } from "@angular/material/snack-bar";
import { ActivatedRoute } from "@angular/router";
import { UserLogin } from "src/app/interfaces/userLogin.interface";
import { Cities, SharedServices } from "src/app/shared/shared.service";
import { forkJoin } from 'rxjs';


export interface petientData {
    numeroDocumento?: string
    apellidosPaciente?: string
    barrio?: string
    correo: string
    departamento?: string
    direccion: string
    eps?: string
    municipio: string
    nombresPaciente?: string
    telefono: string
    fechaInt?: number
    cohorte?: string
    fechaReporte?: string
    partner?: string
    notificacion?: string
    phoneNumber2?: string
    tipoId?: string
    rechazo?: string
    comentarioRechazo?: string
    tipoUsuario?: string
    codCiudadResidenci? : string
    codZonaResidencial?:string
    incapacidad?:string
}

@Component({
    selector: 'app-personal-information-url',
    templateUrl: './personal-information-url.componente.html'
})

export class PersonalInformationUrlComponent implements OnInit {
    infoForm!: FormGroup;
    tipoDocSearchControlNac = new FormControl('');
    filteredCitiesNac: Cities[] = [];
    listCities: Cities[] = []

    campos = [
        { id: 'nombresPaciente', label: 'Nombres', type: 'text', placeholder: '', disabled: true },
        { id: 'apellidosPaciente', label: 'Apellidos', type: 'text', placeholder: '', disabled: true },
        // { id: 'tipo_id', label: 'Tipo de Identificación', type: 'text', placeholder: '', disabled: true },
        { id: 'numeroDocumento', label: 'Número de Identificación', type: 'text', placeholder: '', disabled: true },
        { id: 'direccion', label: 'Dirección', type: 'text', placeholder: 'Ingrese su dirección', disabled: false },
        { id: 'municipio', label: 'Ciudad', type: 'text', placeholder: 'Ingrese su ciudad', disabled: false },
        { id: 'correo', label: 'Correo electrónico', type: 'email', placeholder: 'Ingrese su correo electrónico', disabled: false },
        { id: 'telefono', label: 'Celular', type: 'tel', placeholder: 'Ingrese su número de celular', disabled: false },
    ];

    dataUser!: petientData

    id: string = ''
    numberId: string = ''
    isLoading: boolean = false
    showUpdate: boolean = false
    showNouser: boolean = false
    originalData!: petientData; // Para almacenar los datos originales.
    isFormModified = false; // Para saber si el formulario ha sido modificado.
    listRechazar = [
        { id: '0', label: 'Aceptar medicamento' },
        { id: '1', label: 'Rechazar medicamento' },
    ];

    constructor(
        private fb: FormBuilder,
        private route: ActivatedRoute,
        private sharedService: SharedServices,
        private snackBar: MatSnackBar,
    ) {
        this.infoForm = this.fb.group({
            nombresPaciente: [{ value: '', disabled: true }],
            apellidosPaciente: [{ value: '', disabled: true }],
            // tipo_id: [{ value: '', disabled: true }],
            numeroDocumento: [{ value: '', disabled: true }],
            direccion: ['', Validators.required],
            municipio: ['', Validators.required],
            correo: ['', [Validators.required, Validators.email]],
            telefono: ['', [Validators.required, Validators.pattern('^[0-9]{10}$')]],
            rechazo: ['', Validators.required],
            comentarioRechazo: ['']
        });
    }

    ngOnInit(): void {

        this.isLoading = true;

        this.tipoDocSearchControlNac.valueChanges.subscribe(value => {
            const filter = value?.toLowerCase() || '';
            this.filteredCitiesNac = this.listCities.filter(city =>
                city.ciudad.toLowerCase().includes(filter)
            );
        });

        this.route.queryParams.subscribe(params => {
            this.id = params['id'];
            this.numberId = params['numberId'];

            if (!this.id || !this.numberId) {
                this.showNouser = true;
                this.isLoading = false;
                return;
            }

            const citiesPost = {
                action: "INFO",
                city: ""
            };

            const pacientePost = {
                action: "SEARCH_PACIENTE",
                numberId: this.numberId,
                idPaciente: this.numberId
            };

            forkJoin({
                cities: this.sharedService.postSearchCities(citiesPost),
                user: this.sharedService.postRegisterUser(pacientePost)
            }).subscribe({
                next: ({ cities, user }) => {

                    this.listCities = cities;
                    this.filteredCitiesNac = cities;

                    if (!user) {
                        this.showNouser = true;
                        this.isLoading = false;
                        return;
                    }

                    const municipioCode = this.getMunicipioCodeByName(
                        user.municipio,
                        cities
                    );

                    this.dataUser = user;

                    this.originalData = {
                        direccion: user.direccion,
                        municipio: municipioCode,
                        correo: user.correo,
                        telefono: user.telefono
                    };

                    this.infoForm.patchValue({
                        nombresPaciente: user.nombresPaciente,
                        apellidosPaciente: user.apellidosPaciente,
                        numeroDocumento: user.numeroDocumento,
                        direccion: user.direccion,
                        municipio: municipioCode,
                        correo: user.correo,
                        telefono: user.telefono
                    });

                    this.checkFormChanges();
                    this.isLoading = false;
                },
                error: () => {
                    this.showNouser = true;
                    this.isLoading = false;
                }
            });
        });

        this.infoForm.get('rechazo')?.valueChanges.subscribe(value => {
            const comentarioCtrl = this.infoForm.get('comentarioRechazo');

            if (value === '1') { // 1 = Rechazar
                comentarioCtrl?.setValidators([Validators.required, Validators.minLength(5)]);
            } else {
                comentarioCtrl?.clearValidators();
                comentarioCtrl?.setValue('');
            }

            comentarioCtrl?.updateValueAndValidity();
        });

    }


    getMunicipioCodeByName(nombre: string, cities: Cities[]): string {
        if (!nombre || !cities?.length) return '';

        const city = cities.find(c =>
            c.ciudad?.toLowerCase().trim() === nombre.toLowerCase().trim()
        );

        return city ? city.cod : '';
    }




    onSubmit(change: number): void {
        this.checkFormChanges()
        if (this.infoForm.valid) {
            this.isLoading = true

            const data = {
                action: "UPDATE_PACIENTE",
                change: this.isFormModified ? 0 : 1,
                id: this.id,
                numberId: this.numberId,
                addres: this.infoForm.get('direccion')?.value,
                email: this.infoForm.get('correo')?.value,
                phoneNumber: this.infoForm.get('telefono')?.value,
                city: this.infoForm.get('municipio')?.value,
                rechazo: this.infoForm.get('rechazo')?.value,
                comentarioRechazo: this.infoForm.get('comentarioRechazo')?.value,
                rol: 'Paciente',
            };


            this.sharedService.postRegisterUser(data).subscribe((res: string) => {
                if (res == "UPDATE") {
                    this.isLoading = false
                    this.showUpdate = true
                } else if (res == "ERROR_UPDATE") {
                    this.showMessage('Autorización ya validada')
                    this.isLoading = false
                }
            })


        } else {
            this.infoForm.markAllAsTouched();
        }
    }

    // checkFormChanges() {
    //     const formValues = this.infoForm.value;
    //     this.isFormModified = JSON.stringify(formValues) !== JSON.stringify(this.originalData);
    // }

    checkFormChanges() {
        const formValues = { ...this.infoForm.value };
        const originalValues = { ...this.originalData };

        // 🧠 Eliminamos los campos que NO queremos comparar
        delete formValues.rechazo;
        delete formValues.comentarioRechazo;

        delete originalValues.rechazo;
        delete originalValues.comentarioRechazo;

        // ✅ Comparamos el resto de valores
        this.isFormModified =
            JSON.stringify(formValues) !== JSON.stringify(originalValues);
    }


    showMessage(message: string) {
        this.snackBar.open(message, 'X', {
            duration: 5000,
            panelClass: ['custom-snackbar'],
            verticalPosition: 'top',
            horizontalPosition: 'center',
        });
    }
}